<template>
    <div id='toastMintit' class='toast success'>
        {{params.message}}
    </div>
</template>
<script>
export default {
  components: {
  },
  data () {
    return {
      params: {
        isVisible: false,
        message: '',
        type: 'info'
      }
    }
  },
  methods: {
    open (_e) {
    },
    checkAvailability (e) {

    }
  }
}
</script>

<style scoped>
#toastMintit {
  border: 1px solid tomato;
  background-color: #5cb85c;
  color: #fff;
  height: 40px;
  padding: 10px;
  border-radius: 10px;
  text-align: center;
  font-weight: bold;
  position: absolute;
  width: 100%;
  top: 200px;
}
</style>



// WEBPACK FOOTER //
// src/modules/template/ToastTemplate.vue